var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomizeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1621 13.1111L13.162 10.3333L13.2496 9.49591C13.4049 8.01166 14.5084 6.80139 15.972 6.51V6.51C16.191 6.4664 16.4137 6.44444 16.637 6.44444H31.9999M31.9999 6.44444L27.4654 2M31.9999 6.44444L27.4654 11.1667",
    stroke: "#AB0102",
    strokeOpacity: 0.7,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8378 10.8889L20.8379 13.6667L20.7503 14.5041C20.595 15.9883 19.4915 17.1986 18.0279 17.49V17.49C17.8089 17.5336 17.5861 17.5556 17.3629 17.5556H1.99993M1.99993 17.5556L6.53451 22M1.99993 17.5556L6.53451 12.8333",
    stroke: "#AB0102",
    strokeOpacity: 0.7,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizeRed);
export default __webpack_public_path__ + "static/media/customize-red.515e8ec2e20949c385dc2bf7420d1bee.svg";
export { ForwardRef as ReactComponent };